import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {NextUIProvider} from "@nextui-org/react";
import {ThemeProvider as NextThemesProvider} from "next-themes";
import {LanguageProvider} from "./context/LanguageContext";
import "./utils/i18n"
import "react-multi-carousel/lib/styles.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <NextUIProvider>
    {/* <React.StrictMode> */}
      <LanguageProvider>
        <NextThemesProvider attribute="class" defaultTheme="dark">
          <App />
        </NextThemesProvider>
      </LanguageProvider>
    {/* </React.StrictMode> */}
  </NextUIProvider>
);
